import React from 'react';
import { array, func, oneOf } from 'prop-types';
import { Grid } from '@chaser/components';
import PlanBox from '../../PlanBox/index';
import usePlansData, { SUBSCRIBE_TYPES } from './usePlansData';
import { BillingPeriods } from '../../../../../../util/constants';

const Plans = ({
  plans = [],
  refetchSubscriptionData,
  onSubscribeSuccess,
  appearance = 'default',
  period = BillingPeriods.MONTHLY,
}) => {
  const { updatedPlans, currentPlanPeriodSelected } = usePlansData(plans, period);

  return (
    <Grid minChildWidth={200} gap="small" mt={32}>
      {updatedPlans.map(plan => (
        <PlanBox
          {...plan}
          onSubscribeSuccess={onSubscribeSuccess}
          refetchSubscriptionData={refetchSubscriptionData}
          key={plan.name}
          appearance={appearance}
          isCurrent={plan.isCurrent && currentPlanPeriodSelected}
          period={period}
        />
      ))}
    </Grid>
  );
};

export default Plans;
export { SUBSCRIBE_TYPES };

Plans.propTypes = {
  plans: array.isRequired,
  refetchSubscriptionData: func,
  onSubscribeSuccess: func,
  appearance: oneOf(['default', 'secondary']),
};
